import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Es difícil de mantener?',
    answer: 'No, está diseñado específicamente para personas que odian las rutinas complejas. Se usa en ráfagas de 5 minutos.'
  }, {
    question: '¿Sirve si solo yo tengo ADHD?',
    answer: 'Es cuando más sirve, para crear un puente de comunicación con tu pareja neurotípica.'
  }, {
    question: '¿Tengo que imprimir mucho?',
    answer: 'Solo 3 plantillas clave que deben vivir en tu entorno físico para que funcionen.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 md:py-24 bg-[#1e293b]" data-id="element-10">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-11">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-12">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-13">
          {faqs.map((faq, index) => <div key={index} className="bg-slate-900/50 rounded-2xl border border-slate-700/50 overflow-hidden transition-all duration-300" data-id="element-14">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-15">
                <span className="text-lg md:text-xl font-semibold text-white pr-4" data-id="element-16">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-teal-500 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-17" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-18">
                <div className="p-6 pt-0 text-slate-300 text-lg" data-id="element-19">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}